/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popNftDetail.vue?vue&type=template&id=62c8afe9&scoped=true"
import script from "./popNftDetail.vue?vue&type=script&lang=js"
export * from "./popNftDetail.vue?vue&type=script&lang=js"
import style0 from "./popNftDetail.vue?vue&type=style&index=0&id=62c8afe9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8afe9",
  null
  
)

export default component.exports